import { FunctionComponent } from 'react'
import { WidgetProps } from '@rjsf/core'
import { Autocomplete } from '@dxp-module/common'
import dealerAutocompleteStyles from './dealerAutocomplete.styles'

const DealerAutocompleteInput: FunctionComponent<WidgetProps> = props => {
  const styles = dealerAutocompleteStyles()

  return <Autocomplete classes={styles} {...props} isWithRenderOption={true} />
}

export default DealerAutocompleteInput
